import EngineModule from '../EngineModule';

export default () => EngineModule.all.find(x => x.id === 'oms-customerForm') || new EngineModule.LogicalEngineModule({
	type: 'logical',
	id: 'oms-customerForm',
	dependencies: [
		'oms-basket'
	],
	allowedCustomers: null,
	generateComponentConfiguration() {
		return {};
	},
	insertionPath: null
});
